module.exports = __webpack_public_path__ + "assets/img/icon_concept.ff6e4c13.png";